'use strict';

function soTranslateSettings() {
    var defaultLanguage = '', tables = {};

    return {
        setDefaultLanguage: function(language) {
            defaultLanguage = language;
        },
        $get: function() {
            return {
                setLabelsForLanguage: function(labels) {
                    tables = labels;
                },
                getLabelsForLanguage: function() {
                    return tables;
                },
                getDefaultLanguage: function() {
                    return defaultLanguage;
                },
                goToLanguage: function(label) {
                    return tables[label];
                }
            }
        }
    }
}
export default soTranslateSettings



// WEBPACK FOOTER //
// ./src/app/scripts/modules/soTranslate.js